export const isInvalidName = (name: string | undefined) => !name && 'Name required'

export const isInvalidEmail = (email: string | undefined) => {
  if (!email) {
    return 'Email required'
  } else if (!email.includes('@')) {
    return 'Invalid email'
  }
  return false
}

export const isInvalidPassword = (
  password: string | undefined,
  confirmPassword?: string | undefined
) => {
  if (!password) {
    return 'Password is required'
  } else if (confirmPassword && password !== confirmPassword) {
    return 'Passwords must match'
  }
  return false
}

export const isInvalidURL = (url: string | undefined) => {
  try {
    new URL(url || '')
    return false
  } catch (e) {
    return 'Invalid URL provided'
  }
}

export const isInvalidJSON = (data: string | undefined) => {
  try {
    data && JSON.parse(data)
    return false
  } catch (e) {
    return 'Invalid JSON'
  }
}

export const isEmptyJSON = (data: string | undefined) => {
  if (!data) return 'This field is required'
  try {
    const parsedData = JSON.parse(data)
    if (!parsedData || ['[]', '{}'].includes(data.replaceAll(/\s/g, '')))
      return 'Non empty JSON required'
    return false
  } catch (e) {
    return 'Invalid JSON'
  }
}
